import htmx from "htmx.org";

const blogListingElement = document.querySelector(".blog-listings");
let triggerFilterSubmit: ReturnType<typeof setTimeout> | null = null;

function initBlogControls() {
  if (!blogListingElement) return;

  const controls = blogListingElement.querySelector(".blog-listings-controls");
  const filterAndSortButtons = blogListingElement.querySelectorAll(
    "button.blog-listings-control"
  );
  const drawers = blogListingElement.querySelectorAll(
    ".blog-listing-controls-drawer"
  );
  const drawerFilter = blogListingElement.querySelector(
    ".blog-listing-controls-drawer--filter"
  );
  const searchForm = document.getElementById("blog-search") as HTMLFormElement;
  const closeButtons = blogListingElement.querySelectorAll(".close");
  const sortOptions = blogListingElement.querySelectorAll(".sort-option");
  const sortAndFilterOptions = blogListingElement.querySelectorAll(
    ".sort-option, .filter-option"
  );

  // optimistically set state when requesting
  sortAndFilterOptions.forEach((option) => {
    option.addEventListener("click", (e) => {
      if (!option.classList.contains("active")) {
        // sort options are not multi-select, so remove all others first
        if (option.classList.contains("sort-option")) {
          sortOptions.forEach((optionElement) => {
            optionElement.classList.remove("active");
          });
        }
        option.classList.add("active");
      } else {
        option.classList.remove("active");
      }

      // Filter options don't trigger the query out fo the box,
      // and must have it on a timer to allow users to click filters as needed
      if (option.classList.contains("filter-option")) {
        if (triggerFilterSubmit) {
          clearTimeout(triggerFilterSubmit);
        }
        triggerFilterSubmit = setTimeout(
          blogListingReprocessFilterButton,
          2000
        );
      }
    });
  });

  const deactivateControls = () => {
    filterAndSortButtons.forEach((button) => {
      button.classList.remove("open");
    });
    drawers.forEach((drawer) => {
      drawer.classList.remove("open");
    });
  };

  // close drawers if a click outside occurs
  document.addEventListener("click", (e) => {
    const eventTarget = e.target as HTMLElement;
    if (!controls?.contains(eventTarget)) {
      // If the filter drawer specifically was open, trigger filter almost immediately.
      if (drawerFilter?.classList.contains("open") && triggerFilterSubmit) {
        clearTimeout(triggerFilterSubmit);
        triggerFilterSubmit = setTimeout(blogListingReprocessFilterButton, 100);
      }
      deactivateControls();
    }
  });

  // set up filter and sort button events
  filterAndSortButtons.forEach((button) => {
    const buttonElm = button as HTMLElement;
    const controlType = buttonElm.dataset.control;
    // get matching drawer
    const drawer = blogListingElement?.querySelector(
      `.blog-listing-controls-drawer[data-control="${controlType}"]`
    );
    buttonElm.addEventListener("click", () => {
      // remove all first
      deactivateControls();

      if (buttonElm.classList.contains("open")) {
        drawer?.classList.remove("open");
        buttonElm.classList.remove("open");
        return;
      }
      drawer?.classList.add("open");
      buttonElm.classList.add("open");
    });
  });

  // set up click events for close button in mobile version
  closeButtons.forEach((button) => {
    button.addEventListener("click", () => {
      deactivateControls();
    });
  });

  // set up search functionality
  searchForm?.addEventListener("submit", (e) => {
    e.preventDefault();
    const query = searchForm.querySelector(
      "[type='search']"
    ) as HTMLInputElement;
    if (query?.value) {
      window.location.href = `https://gettinghealthy.ca/search?q=${encodeURIComponent(
        query.value
      )}`;
    }
  });
}

if (blogListingElement) {
  // this should be possible with HTMX attributes in HTML but it is not working, so here we are
  window.addEventListener("htmx:afterSwap", () => {
    document.getElementById("blog-listings-target")?.scrollIntoView();
    initBlogControls();
  });

  initBlogControls();
}

function blogListingReprocessFilterButton() {
  if (!blogListingElement) return;

  const filterOptions =
    blogListingElement?.querySelectorAll<HTMLButtonElement>(".filter-option");

  const activeInputs: string[] = [];
  if (filterOptions) {
    for (const filterOption of filterOptions) {
      if (
        filterOption.classList.contains("active") &&
        filterOption.dataset.filter
      ) {
        activeInputs.push(filterOption.dataset.filter);
      }
    }
  }

  const urlParams = new URLSearchParams(window.location.search);
  if (activeInputs.length) {
    urlParams.set("category", activeInputs.toString());
  } else {
    urlParams.delete("category");
  }
  const sortOption = blogListingElement.querySelector<HTMLAnchorElement>(
    ".sort-option.active"
  );
  if (sortOption && sortOption.dataset.sort) {
    urlParams.set("sort", sortOption.dataset.sort);
  } else {
    urlParams.delete("sort");
  }

  let url = window.location.toString();
  url = urlParams.toString() ? url + "?" + urlParams.toString() : url;

  const triggerEl = document.createElement("a");
  triggerEl.setAttribute("href", url);
  triggerEl.setAttribute("hx-get", url);
  triggerEl.setAttribute("hx-target", "#blog-listings-target");
  triggerEl.setAttribute("hx-indicator", ".blog-listings");

  blogListingElement.prepend(triggerEl);
  htmx.process(triggerEl);

  triggerEl.click();
  triggerEl.remove();

  triggerFilterSubmit = null;
}
